import BaseService from './_base.service';

export const stadisticsService = {
    search
};

function search(callback) {
    return BaseService.get("/stadistics", callback, true)
}
